export const DEFAULT_PAGE = 1;
export const PDF_TO_CSS_UNITS = 96 / 72;
export const PDF_PRINT_SCALE = 1;
export const LOADING_SPINNER_DELAY_MS = 50;
export const HIGH_DETAIL_RENDER_DEBOUNCE_MS = 500;
export const LOW_DETAIL_RESOLUTION = 1024;
